import { api } from '@/helpers/api'

export default {
  getPages () {
    return api.get('common/frontend/pages').then(response => {
      return Promise.resolve(response.data)
    })
  },
  getSettings () {
    return api.get('common/frontend/settings').then(response => {
      return Promise.resolve(response.data)
    })
  },
  getFaq () {
    return api.get('common/faq?project=customer').then(response => {
      return Promise.resolve(response.data)
    })
  }
}
